document.addEventListener('DOMContentLoaded', function () {
  // ---- Lazy video loading for non-critical motion blocks ----
  (function () {
    var videos = Array.prototype.slice.call(document.querySelectorAll('video[data-ldn-lazy-video][data-src]'));
    if (!videos.length) return;

    function loadVideo(video) {
      if (video.dataset.ldnLoaded === 'true') return;
      video.src = video.dataset.src;
      video.dataset.ldnLoaded = 'true';
      video.load();
      if (!document.hidden) video.play().catch(function () {});
    }

    function pauseOffscreen(video, visible) {
      if (!video.dataset.ldnLoaded) return;
      if (visible && !document.hidden) video.play().catch(function () {});
      else video.pause();
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadVideo);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) loadVideo(video);
        pauseOffscreen(video, entry.isIntersecting);
      });
    }, { rootMargin: '240px 0px', threshold: 0.18 });

    videos.forEach(function (video) { observer.observe(video); });
    document.addEventListener('visibilitychange', function () {
      videos.forEach(function (video) {
        if (document.hidden) video.pause();
      });
    });
  })();

  // ---- Hero carousel ----
  document.querySelectorAll('[data-ldn-hero]').forEach(function (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-ldn-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-ldn-dot]'));
    if (slides.length < 2) return;
    var index = 0;
    var intervalMs = parseInt(hero.getAttribute('data-ldn-interval'), 10) || 4500;
    var timer = null;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }
    function next() { show(index + 1); }
    function prev() { show(index - 1); }
    function restart() {
      if (timer) clearInterval(timer);
      timer = setInterval(next, intervalMs);
    }

    hero.querySelectorAll('[data-ldn-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { next(); restart(); });
    });
    hero.querySelectorAll('[data-ldn-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { prev(); restart(); });
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); restart(); });
    });

    show(0);
    restart();
  });

  // ---- Hero banner (campaign slider) ----
  document.querySelectorAll('[data-ldn-herobanner]').forEach(function (banner) {
    var slides = Array.prototype.slice.call(banner.querySelectorAll('[data-ldn-hb-slide]'));
    var dots = Array.prototype.slice.call(banner.querySelectorAll('[data-ldn-hb-dot]'));
    if (slides.length < 2) return;
    var index = 0;
    var autoplay = banner.getAttribute('data-ldn-autoplay') === 'true';
    var intervalMs = parseInt(banner.getAttribute('data-ldn-interval'), 10) || 6000;
    var timer = null;

    function activateMedia(slide, active) {
      var video = slide.querySelector('video');
      if (!video) return;
      if (active) { video.play().catch(function () {}); }
      else { video.pause(); }
    }

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, si) {
        var active = si === index;
        s.classList.toggle('is-active', active);
        activateMedia(s, active);
      });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }
    function next() { show(index + 1); }
    function prev() { show(index - 1); }
    function restart() {
      if (!autoplay) return;
      if (timer) clearInterval(timer);
      timer = setInterval(next, intervalMs);
    }

    banner.querySelectorAll('[data-ldn-hb-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { next(); restart(); });
    });
    banner.querySelectorAll('[data-ldn-hb-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { prev(); restart(); });
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); restart(); });
    });

    var startX = null;
    banner.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    banner.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 40) { diff < 0 ? next() : prev(); restart(); }
      startX = null;
    }, { passive: true });

    show(0);
    restart();
  });

  // ---- Reviews carousel (real reviews from Judge.me, scroll-snap based) ----
  document.querySelectorAll('[data-ldn-reviews-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-ldn-reviews-track]');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-ldn-reviews-slide]'));
    if (!track || slides.length < 2) return;

    var dotsWrap = carousel.querySelector('[data-ldn-reviews-dots]');
    var prevBtn = carousel.querySelector('[data-ldn-reviews-prev]');
    var nextBtn = carousel.querySelector('[data-ldn-reviews-next]');
    var autoplay = carousel.getAttribute('data-autoplay') === 'true';
    var intervalMs = parseInt(carousel.getAttribute('data-interval'), 10) || 6000;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) autoplay = false;

    var timer = null;
    var paused = false;
    var resumeTimer = null;

    function perView() {
      var w = window.innerWidth;
      if (w >= 1000) return 3;
      if (w >= 750) return 2;
      return 1;
    }
    function pageCount() {
      return Math.max(1, Math.ceil(slides.length / perView()));
    }
    function currentPage() {
      var pageWidth = track.clientWidth;
      if (!pageWidth) return 0;
      return Math.round(track.scrollLeft / pageWidth);
    }
    function goToPage(i) {
      var pageWidth = track.clientWidth;
      track.scrollTo({ left: pageWidth * i, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var pages = pageCount();
      for (var i = 0; i < pages; i++) {
        (function (idx) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ldn-reviews__dot';
          dot.setAttribute('aria-label', 'Ir a la página ' + (idx + 1));
          dot.addEventListener('click', function () { goToPage(idx); pauseThenResume(); });
          dotsWrap.appendChild(dot);
        })(i);
      }
      updateDots();
    }
    function updateDots() {
      if (!dotsWrap) return;
      var dots = Array.prototype.slice.call(dotsWrap.children);
      var active = currentPage();
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
    }
    function next() {
      var pages = pageCount();
      var n = currentPage() + 1;
      goToPage(n >= pages ? 0 : n);
    }
    function prev() {
      var p = currentPage() - 1;
      goToPage(p < 0 ? pageCount() - 1 : p);
    }
    function restart() {
      if (timer) clearInterval(timer);
      if (!autoplay || paused) return;
      timer = setInterval(next, intervalMs);
    }
    function pauseThenResume() {
      paused = true;
      if (timer) clearInterval(timer);
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; restart(); }, intervalMs);
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); pauseThenResume(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); pauseThenResume(); });

    carousel.addEventListener('mouseenter', function () { paused = true; if (timer) clearInterval(timer); });
    carousel.addEventListener('mouseleave', function () { paused = false; restart(); });
    carousel.addEventListener('focusin', function () { paused = true; if (timer) clearInterval(timer); });
    carousel.addEventListener('focusout', function () { paused = false; restart(); });
    track.addEventListener('touchstart', function () { paused = true; if (timer) clearInterval(timer); }, { passive: true });
    track.addEventListener('touchend', function () { pauseThenResume(); }, { passive: true });

    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateDots, 80);
    }, { passive: true });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildDots, 150);
    });

    buildDots();
    restart();
  });

  // ---- Footer accordion (mobile only; desktop columns stay static via CSS) ----
  document.querySelectorAll('[data-ldn-footer-accordion]').forEach(function (col) {
    var toggle = col.querySelector('[data-ldn-footer-toggle]');
    var panel = col.querySelector('[data-ldn-footer-panel]');
    var inner = panel ? panel.querySelector('.ldn-footer__col-panel-inner') : null;
    if (!toggle || !panel || !inner) return;

    function isDesktop() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    function setOpen(open) {
      col.setAttribute('data-open', open ? 'true' : 'false');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.style.maxHeight = open ? inner.scrollHeight + 'px' : '0px';
    }

    setOpen(false);

    toggle.addEventListener('click', function () {
      if (isDesktop()) return;
      var open = col.getAttribute('data-open') === 'true';
      setOpen(!open);
    });

    window.addEventListener('resize', function () {
      if (isDesktop()) {
        panel.style.maxHeight = '';
      } else if (col.getAttribute('data-open') === 'true') {
        panel.style.maxHeight = inner.scrollHeight + 'px';
      }
    });
  });

  // ---- Campaigns carousel (banners/offers, block-based) ----
  document.querySelectorAll('[data-ldn-campaigns]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ldn-campaign-slide]'));
    if (slides.length === 0) return;

    var viewport = root.querySelector('.ldn-campaigns__viewport');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ldn-campaign-dot]'));
    var prevBtn = root.querySelector('[data-ldn-campaign-prev]');
    var nextBtn = root.querySelector('[data-ldn-campaign-next]');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var intervalMs = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) autoplay = false;

    var index = 0;
    var timer = null;
    var paused = false;
    var seen = {};

    function activateVideo(slide, active) {
      var video = slide.querySelector('video');
      if (!video) return;
      if (active) {
        if (!video.getAttribute('src') && video.dataset.src) video.setAttribute('src', video.dataset.src);
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    }

    function trackView(slide) {
      var idx = slide.getAttribute('data-campaign-index');
      if (seen[idx]) return;
      seen[idx] = true;
      document.dispatchEvent(new CustomEvent('campaign:view', {
        detail: {
          id: slide.getAttribute('data-campaign-id'),
          label: slide.getAttribute('data-campaign-label'),
          index: idx
        }
      }));
    }

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, si) {
        var active = si === index;
        s.classList.toggle('is-active', active);
        activateVideo(s, active);
        if (active) trackView(s);
      });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }
    function next() { show(index + 1); }
    function prev() { show(index - 1); }
    function restart() {
      if (timer) clearInterval(timer);
      if (!autoplay || paused || slides.length < 2) return;
      timer = setInterval(next, intervalMs);
    }
    function pauseThenResume() {
      paused = true;
      if (timer) clearInterval(timer);
      setTimeout(function () { paused = false; restart(); }, intervalMs);
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); pauseThenResume(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); pauseThenResume(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); pauseThenResume(); });
    });

    root.addEventListener('mouseenter', function () { paused = true; if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', function () { paused = false; restart(); });
    root.addEventListener('focusin', function () { paused = true; if (timer) clearInterval(timer); });
    root.addEventListener('focusout', function () { paused = false; restart(); });

    var startX = null;
    if (viewport) {
      viewport.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        paused = true;
        if (timer) clearInterval(timer);
      }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        if (startX !== null) {
          var diff = e.changedTouches[0].clientX - startX;
          if (Math.abs(diff) > 40) { diff < 0 ? next() : prev(); }
          startX = null;
        }
        pauseThenResume();
      }, { passive: true });
    }

    root.querySelectorAll('[data-ldn-campaign-cta]').forEach(function (cta) {
      cta.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('campaign:cta_click', {
          detail: {
            id: cta.getAttribute('data-campaign-id'),
            label: cta.getAttribute('data-campaign-label')
          }
        }));
      });
    });

    show(0);
    restart();
  });

  // ---- Awards mobile "ver todos" toggle ----
  document.querySelectorAll('[data-ldn-awards-toggle]').forEach(function (btn) {
    var wrap = btn.closest('.ldn-awards__mobile');
    var panel = wrap ? wrap.querySelector('[data-ldn-awards-secondary]') : null;
    var textEl = btn.querySelector('[data-ldn-awards-toggle-text]');
    var inner = panel ? panel.querySelector('.ldn-awards__mobile-grid--secondary') : null;
    if (!panel || !textEl || !inner) return;

    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      if (open) {
        panel.style.maxHeight = '0px';
        btn.setAttribute('aria-expanded', 'false');
        textEl.textContent = 'Ver todos los reconocimientos ↓';
      } else {
        panel.style.maxHeight = inner.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
        textEl.textContent = 'Ocultar reconocimientos ↑';
      }
    });

    window.addEventListener('resize', function () {
      if (btn.getAttribute('aria-expanded') === 'true') {
        panel.style.maxHeight = inner.scrollHeight + 'px';
      }
    });
  });

  // ---- Copy coupon code ----
  document.querySelectorAll('[data-ldn-copy]').forEach(function (btn) {
    var code = btn.getAttribute('data-ldn-copy');
    var label = btn.querySelector('[data-ldn-copy-label]');
    if (!label) return;
    var originalText = label.textContent;
    btn.addEventListener('click', function () {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).catch(function () {});
      }
      label.textContent = label.getAttribute('data-ldn-copied-text') || '¡Copiado!';
      setTimeout(function () { label.textContent = originalText; }, 1800);
    });
  });

  // ---- Header mobile menu (hamburger <details> controls a sibling panel) ----
  document.querySelectorAll('[data-ldn-mobile-menu-toggle]').forEach(function (details) {
    var scope = details.closest('.ldn-scope');
    var panel = scope ? scope.querySelector('[data-ldn-mobile-menu-panel]') : null;
    if (!panel) return;
    details.addEventListener('toggle', function () {
      panel.style.display = details.open ? 'flex' : 'none';
    });
    panel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        details.removeAttribute('open');
        panel.style.display = 'none';
      });
    });
  });

  // ---- Cart drawer + AJAX add to cart ----
  (function () {
    var drawer = document.querySelector('[data-ldn-cart-drawer]');
    if (!drawer) return;

    var itemsEl = drawer.querySelector('[data-ldn-cart-items]');
    var footEl = drawer.querySelector('[data-ldn-cart-foot]');
    var subtotalEl = drawer.querySelector('[data-ldn-cart-subtotal]');
    var currency = drawer.getAttribute('data-currency') || 'CLP';
    var countEls = document.querySelectorAll('[data-ldn-cart-count]');

    function formatMoney(cents) {
      try {
        return (cents / 100).toLocaleString('es-CL', { style: 'currency', currency: currency, maximumFractionDigits: 0 });
      } catch (e) {
        return '$' + Math.round(cents / 100);
      }
    }

    function updateCartCount(count) {
      countEls.forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
    }

    function renderCart(cart) {
      updateCartCount(cart.item_count);
      if (!cart.items || cart.items.length === 0) {
        itemsEl.innerHTML = '<div class="ldn-cartdrawer__empty">Tu carrito está vacío.</div>';
        footEl.style.display = 'none';
        return;
      }
      footEl.style.display = 'flex';
      subtotalEl.textContent = formatMoney(cart.total_price);
      itemsEl.innerHTML = cart.items.map(function (item) {
        var variantLine = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="ldn-cartitem__variant">' + item.variant_title + '</p>' : '';
        return (
          '<div class="ldn-cartitem">' +
            '<img class="ldn-cartitem__img" src="' + (item.image || '') + '" alt="' + (item.product_title || '') + '" loading="lazy">' +
            '<div class="ldn-cartitem__info">' +
              '<p class="ldn-cartitem__title">' + item.product_title + '</p>' +
              variantLine +
              '<div class="ldn-cartitem__row">' +
                '<span class="ldn-cartitem__qty">Cant. ' + item.quantity + '</span>' +
                '<span class="ldn-cartitem__price">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    function fetchCart() {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    function openDrawer() {
      drawer.setAttribute('data-open', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.setAttribute('data-open', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    drawer.querySelectorAll('[data-ldn-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Cart icon in header opens the drawer (falls back to /cart if JS fails)
    document.querySelectorAll('[data-ldn-cart-toggle]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(renderCart);
        openDrawer();
      });
    });

    // Add-to-cart buttons on product cards
    document.querySelectorAll('[data-ldn-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-loading')) return;
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.classList.add('is-loading');
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            return fetchCart();
          })
          .then(function (cart) {
            renderCart(cart);
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            var label = btn.querySelector('.ldn-cta-label');
            var originalHTML = label ? label.innerHTML : null;
            if (label) label.innerHTML = '<span>Agregado &#10003;</span>';
            openDrawer();
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.disabled = false;
              if (label && originalHTML) label.innerHTML = originalHTML;
            }, 1800);
          })
          .catch(function () {
            var label = btn.querySelector('.ldn-cta-label');
            var originalHTML = label ? label.innerHTML : null;
            btn.classList.remove('is-loading');
            btn.classList.add('is-error');
            if (label) label.innerHTML = '<span>Intenta nuevamente</span>';
            setTimeout(function () {
              btn.classList.remove('is-error');
              btn.disabled = false;
              if (label && originalHTML) label.innerHTML = originalHTML;
            }, 2200);
          });
      });
    });
  })();
});
